import { render, staticRenderFns } from "./center-bottom.vue?vue&type=template&id=4ac92ab6&scoped=true&"
import script from "./center-bottom.vue?vue&type=script&lang=js&"
export * from "./center-bottom.vue?vue&type=script&lang=js&"
import style0 from "./center-bottom.vue?vue&type=style&index=0&id=4ac92ab6&scoped=true&lang=css&"
import style1 from "./center-bottom.vue?vue&type=style&index=1&id=4ac92ab6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac92ab6",
  null
  
)

export default component.exports